import React, { FC, ReactNode } from 'react'
import { Cell, ColumnProps } from 'fixed-data-table-2'

type SortHeaderCellProps = ColumnProps & {
    className?: string
    onSortChange: Function
    sortDirection: any
    sortBy: string
    title: ReactNode
}

const SORT_TYPES = {
    ASC: 'ASC',
    DESC: 'DESC',
}

export const SortHeaderCell: FC<SortHeaderCellProps> = ({ onSortChange, sortDirection, sortBy, title, ...rest }) => {
    let indicator = sortDirection ? (sortDirection === SORT_TYPES.DESC ? '↓' : '↑') : ''

    if (rest.columnKey !== sortBy) {
        indicator = ''
    }

    return (
        <Cell {...rest}>
            <div
                className="table-sort-header"
                onClick={(ev) => {
                    ev.preventDefault()

                    if (onSortChange) {
                        onSortChange(
                            rest.columnKey,
                            sortDirection
                                ? sortDirection === SORT_TYPES.DESC
                                    ? SORT_TYPES.ASC
                                    : SORT_TYPES.DESC
                                : SORT_TYPES.ASC,
                        )
                    }
                }}
            >
                {title} {indicator}
            </div>
        </Cell>
    )
}
